"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableSync = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactPerfectScrollbar = _interopRequireDefault(require("react-perfect-scrollbar"));

var _moize = _interopRequireDefault(require("moize"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.error"));

var _knotchincWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.loading"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TableSync = /*#__PURE__*/function (_Component) {
  _inherits(TableSync, _Component);

  var _super = _createSuper(TableSync);

  function TableSync(props) {
    var _this;

    _classCallCheck(this, TableSync);

    _this = _super.call(this, props);

    _this.requestUpdateList = function () {
      return _this.updateList();
    };

    _this.scrollNode = undefined;
    _this.container = undefined;
    _this.state = {
      sideBarData: null
    };
    _this.memoRankings = _moize["default"].deep(function (data) {
      return _this.calculateMinMaxRankings(data);
    });
    return _this;
  }

  _createClass(TableSync, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          loadOnScroll = _this$props.loadOnScroll,
          pageSize = _this$props.pageSize,
          setFilters = _this$props.setFilters,
          actionType = _this$props.actionType,
          data = _this$props.data,
          SideBar = _this$props.SideBar,
          tableData = _this$props.tableStore.data;
      var sideBarData = this.state.sideBarData;

      if (pageSize) {
        setFilters({
          pageSize: pageSize
        }, actionType);
      }

      this.getScrollNode();

      if (loadOnScroll && this.scrollNode) {
        this.initLoadOnScroll();
      }

      this.fetchData();

      if (SideBar && sideBarData === null) {
        this.setSideBar(tableData[0] || data[0]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          SideBar = _this$props2.SideBar,
          tableData = _this$props2.tableStore.data,
          data = _this$props2.data;
      var sideBarData = this.state.sideBarData;
      this.fetchData();

      if (prevProps.container !== this.props.container) {
        this.getScrollNode();
        this.initLoadOnScroll();
      }

      if (SideBar && sideBarData === null) {
        this.setState({
          sideBarData: tableData[0] || data[0]
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearScroll();
    }
  }, {
    key: "getScrollNode",
    value: function getScrollNode() {
      var fixedHeight = this.props.fixedHeight;
      var scrollNode = null; // container being null means the variable is set but the container is not yet available

      if (fixedHeight) {
        // we do nothing if it's null
        // container being undefined means the variable wasn't set so we're listening to the window
        if (typeof this._scrollContainerRef === 'undefined') {
          scrollNode = window;
        } // container being defined means we need to listen to it instead


        if (this._scrollContainerRef) {
          scrollNode = this._scrollContainerRef._container;
        }
      } else {
        scrollNode = window;
      }

      this.scrollNode = scrollNode;
    }
  }, {
    key: "setSideBar",
    value: function setSideBar(data) {
      var sideBarData = this.state.sideBarData;
      var isCurrent = data && data.public_id && this.isCurrentRow(data); // If user clicks on the same row (isCurrent) we'll prevent a rerender

      if (isCurrent) return; // If incoming row data is not the current sideBarData we'll update state

      if (JSON.stringify(data) !== JSON.stringify(sideBarData)) {
        this.setState({
          sideBarData: data
        });
      } else {
        this.setState({
          sideBarData: null
        });
      }
    }
    /**
     * Checks the current data in sideBarData to see if the row with
     * the current value should be highlighted
     *
     * When using TableSync, we must pass in a resourceId to determine what
     * kind of value the row is displaying
     */

  }, {
    key: "isCurrentRow",
    value: function isCurrentRow(data) {
      var sideBarData = this.state.sideBarData;
      var resourceId = this.props.resourceId;
      var value = data[resourceId];

      if (sideBarData && sideBarData[resourceId] && sideBarData[resourceId] === value) {
        return true;
      }

      return false;
    }
  }, {
    key: "clearScroll",
    value: function clearScroll() {
      if (this.scrollNode) {
        this.scrollNode.removeEventListener('scroll', this.requestUpdateList, false);
      }
    }
  }, {
    key: "initLoadOnScroll",
    value: function initLoadOnScroll() {
      if (this.scrollNode) {
        this.scrollNode.removeEventListener('scroll', this.requestUpdateList, false);
        this.scrollNode.addEventListener('scroll', this.requestUpdateList, false);
      }
    }
  }, {
    key: "calculateMinMaxRankings",
    value: function calculateMinMaxRankings() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!data.length) return;
      /*
        * When dealing with rankings, we need find the lowest & highest common numerators, as these values
        * can often times tie, for example:
        * { unit_id, page views, rank }
        *  abc, 100 , 1/3
        *  def, 100, 1/3
        *  geh, 50, 2/3
        *
       */
      // Establish rank keys first

      var minMaxRankingMap = Object.keys(data[0]).filter(function (key) {
        return key.includes('rank_');
      }).reduce(function (acc, curr) {
        return _objectSpread({}, acc, _defineProperty({}, curr, {
          ranks: []
        }));
      }, {}); // Loop through data and record if any of the rank keys would override a min or a max

      data.forEach(function (item) {
        for (var key in item) {
          if (minMaxRankingMap[key]) {
            // Add value to ranks array for this rank key
            minMaxRankingMap[key].ranks.push(item[key]);
          }
        }
      }); // Now that we've recorded all the possible ranks, we'll determine the min/max for each key

      for (var key in minMaxRankingMap) {
        minMaxRankingMap[key].min = Math.min.apply(Math, _toConsumableArray(minMaxRankingMap[key].ranks));
        minMaxRankingMap[key].max = Math.max.apply(Math, _toConsumableArray(minMaxRankingMap[key].ranks));
        delete minMaxRankingMap[key].ranks; // Array of all longer needed
      }

      return minMaxRankingMap;
    }
  }, {
    key: "updateList",
    value: function updateList() {
      var _this$props3 = this.props,
          _this$props3$tableSto = _this$props3.tableStore,
          fetching = _this$props3$tableSto.fetching,
          pagination = _this$props3$tableSto.pagination,
          setFilters = _this$props3.setFilters,
          actionType = _this$props3.actionType;
      var current = pagination.current,
          max = pagination.max;
      var y = this.scrollNode === window ? window.pageYOffset : this.scrollNode.scrollTop;
      var closeToBottom;

      if (this.scrollNode === window) {
        closeToBottom = document.documentElement.scrollHeight - window.outerHeight - y < 1500;
      } else {
        closeToBottom = this.scrollNode.scrollHeight - y - this.scrollNode.clientHeight < 500;
      }

      if (current && max && y > 0 && closeToBottom) {
        var isMax = current === max;

        if (!fetching && !isMax) {
          setFilters({
            pageNum: current + 1
          }, actionType);
        }
      }
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this$props4 = this.props,
          _this$props4$tableSto = _this$props4.tableStore,
          shouldFetch = _this$props4$tableSto.shouldFetch,
          clear = _this$props4$tableSto.clear,
          fetch = _this$props4.fetch; // a way to still call table endpoints while we extract filtering from tableSync

      if (shouldFetch) {
        if (this.request) this.request.abort();
        this.request = fetch(clear);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          children = _this$props5.children,
          tableStore = _this$props5.tableStore,
          fetch = _this$props5.fetch,
          actionType = _this$props5.actionType,
          fixedHeight = _this$props5.fixedHeight,
          _this$props5$printVie = _this$props5.printView,
          printView = _this$props5$printVie === void 0 ? false : _this$props5$printVie,
          headerTexts = _this$props5.headerTexts,
          noHeader = _this$props5.noHeader,
          SideBar = _this$props5.SideBar,
          rowHeight = _this$props5.rowHeight,
          hasRanking = _this$props5.hasRanking,
          totalLength = _this$props5.totalLength;
      var fetched = tableStore.fetched,
          fetching = tableStore.fetching,
          status = tableStore.status;
      var sideBarData = this.state.sideBarData;
      var hasSideBar = typeof SideBar !== 'undefined'; // allow for data override to only display any data list

      var data = this.props.data || tableStore.data;
      var minMaxRankingMap = null;

      if (hasRanking) {
        minMaxRankingMap = this.memoRankings(data);
      }

      if (process.env === 'development' && children.length > 1) {
        console.warn('TableSync should only have one child, a Row');
        return null;
      } // support for new Row API - pass everything in the props


      var Row = this.props.Row; // support for old Row API - use the children

      if (children && children.type) {
        Row = children.type;
      }

      if (process.env === 'development' && Row.name.indexOf('Row') === -1) {
        console.warn("the only child that can be passed is a Row. Passed: ".concat(children.type.name));
        return null;
      }

      var childrenProps = children ? children.props : {};
      var noData = fetched && data.length === 0 && status === 'success';
      var error = fetched && (status === 'error' || status === 'not found'); // some cells will be disabled if we don't get an interval returned

      var tableContent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, data.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement(Row, _extends({
          data: item,
          length: totalLength || data.length,
          key: "".concat(Row.name, "_").concat(index),
          sortFilters: tableStore.sortFilters,
          onClick: hasSideBar ? function (e) {
            return _this2.setSideBar(e);
          } : null,
          current: _this2.isCurrentRow(item),
          rowHeight: rowHeight,
          hasRanking: hasRanking,
          minMaxRankingMap: minMaxRankingMap,
          hasSideBar: hasSideBar,
          printView: printView
        }, childrenProps));
      }), noData && /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
        noData: true
      }), fetching && /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2["default"], null), error && /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
        fetchError: true,
        reload: function reload() {
          return fetch(true);
        }
      }));

      return /*#__PURE__*/_react["default"].createElement(_styled.StyledTableContainer, {
        printView: printView,
        fixedHeight: fixedHeight
      }, /*#__PURE__*/_react["default"].createElement(_styled.StyledTable, {
        ref: function ref(_ref2) {
          _this2.container = _ref2;
        },
        sideBar: hasSideBar,
        printView: printView,
        fixedHeight: fixedHeight
      }, !noHeader && /*#__PURE__*/_react["default"].createElement(Row, _extends({
        header: true,
        sortFilters: tableStore.sortFilters,
        actionType: actionType
      }, childrenProps, {
        headerTexts: headerTexts,
        hasSideBar: hasSideBar,
        printView: printView
      })), /*#__PURE__*/_react["default"].createElement(_styled.StyledTableBody, {
        printView: printView,
        fixedHeight: fixedHeight
      }, /*#__PURE__*/_react["default"].createElement(_reactPerfectScrollbar["default"], {
        option: {
          wheelPropagation: true
        },
        ref: function ref(_ref) {
          _this2._scrollContainerRef = _ref;
        }
      }, tableContent))), sideBarData ? /*#__PURE__*/_react["default"].createElement(SideBar, {
        data: sideBarData,
        length: data.length
      }) : null);
    }
  }]);

  return TableSync;
}(_react.Component);

exports.TableSync = TableSync;
TableSync.defaultProps = {
  tableSize: 10,
  tableStore: {
    fetched: false,
    fetching: false,
    status: null,
    filters: {},
    data: []
  }
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setFilters: function setFilters(sortFilters, type) {
      return dispatch({
        type: type,
        sortFilters: sortFilters
      });
    }
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(TableSync);

exports["default"] = _default;

//# sourceMappingURL=TableSync.js.map